import { color } from '@op/opds.tokens';
import ScoreArcLayer from './ScoreArcLayer';
import ScoreNeedle from './ScoreNeedle';
import classes from './Score.module.scss';

interface ScoreMeterProps {
  scorePercent: number;
}

const ScoreMeter = ({ scorePercent }: ScoreMeterProps): JSX.Element => {
  return (
    <div className={classes.scoreMeterContainer} aria-hidden="true">
      <ScoreArcLayer startAngle={-90} endAngle={-30} color={color.background.tertiary} />
      <ScoreArcLayer startAngle={-30} endAngle={30} color="#d7d7d7" />
      <ScoreArcLayer startAngle={30} endAngle={90} color={color.indicator.passive} />
      <ScoreNeedle angleInDegrees={(180 * scorePercent) / 100} />
    </div>
  );
};

export default ScoreMeter;
